module.exports = __webpack_public_path__ + "static/media/step4.7e3a31a0.png";